import React, {Fragment} from 'react';

import PanelControlDelete from "../UI/ReactPanelControlDelete";
import DropdownPPPlusReasons from "../UI/ReactDropdownPPPlusReasons";
import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";
import MultiPageForm from "../Base/ReactMultiPageForm";
import SpinnerDiv from "ui/SpinnerDiv";
import UserInputCheckbox from "../UI/ReactUserInputCheckbox";
import UserInputTextarea from "../UI/ReactUserInputTextarea";
import DropdownYesNo from "../UI/ReactDropdownYesNo";
import ReactDropdownAchievementGroupsWithNotifications from "../UI/ReactDropdownAchievementGroupsWithNotifications";
import ReactTooltip from "react-tooltip";
import {getDataFromResponse} from '../DataFunctions/BaseDataFns'
import {getChildPPPlusForYear, updatePPPlusForChild} from "root/DataFunctions/PPPlusFns";

export default class ChildPupilPremiumPlus extends MultiPageForm
{
    static get defaultProps()
    {
        var v =
            {
                title: 'title',
                panelStyle: 'panel-default panel-subject',
                attendanceData: null,
				review_data: null,
				reasonRows: 3,
				tabIndex: 0,
				mode: 'view'
            }

        return v ;
    }

	constructor(props) 
	{
		super(props);

		this.state.mode = this.props.mode ;
		this.state.loading = props.review_data == null ? true : false ;
		this.state.ppplus = props.review_data !== null ? props.review_data.ppplus : null ;
		this.state.isPPPlusExempt = props.review_data !== null ? this.getPPPlusExemptState(this.state.ppplus) : null ;
		this.state.spendReason = props.review_data !== null ? this.getPPPlusSpendReason(this.state.ppplus) : null ;

		this.onExemptFlagChange = this.onExemptFlagChange.bind(this) ;

		this.keyCount = 0 ;
	}

	getPPPlusExemptState ( ppplusRecord )
	{
		return ppplusRecord?.is_exempt == 1 ? true : false ;
	}

	getPPPlusSpendReason ( ppplusRecord )
	{
		return +(ppplusRecord?.spend_reason_id)  ;
	}

	componentDidMount()
	{
		if ( this.props.review_data == null )
		{
			this.getData(this.props.child_id, this.props.year) ;
		}
	}

	componentDidUpdate(prevProps, prevState)
	{
		if (prevProps.year !== this.props.year)
		{
			this.getData( this.props.child_id, this.props.year ) ;
		}
	}

	updatePPPlus ( reviewData, callback )
	{
		updatePPPlusForChild ( reviewData, (response) =>
		{
			this.setDirty ( false ) ;

			if ( callback != null )
			{
				callback() ;
			}
		})
	}

	getData ( child_id, year_id )
	{
		getChildPPPlusForYear ( child_id, year_id, (response)=>
		{
			const recs = getDataFromResponse( response ) ;

			if ( recs.length > 0 )
			{
				const ppplus = recs[0] ;

				let isPPPlusExempt = this.getPPPlusExemptState(ppplus) ;
				let spendReason = this.getPPPlusSpendReason(ppplus) ;

				this.setState ( { loading: false , ppplus : ppplus, isPPPlusExempt: isPPPlusExempt, spendReason: spendReason }) ;
			}
			else
			{
				this.setState ( { loading: false , ppplus : [], isPPPlusExempt: true, spendReason :null }) ;
			}

		})
	}

	boolToInt ( bValue )
	{
		return bValue == true ? 1 : 0 ;
	}

	getFormData()
	{
		let data = {} ;

		data.ppplus_id = this.state.ppplus['ppplus_id'];
		data.is_exempt = this.boolToInt( this.state.isPPPlusExempt ) ;

		if ( this.state.isPPPlusExempt == true )
		{
			data.spend_reason_id = '' ;
			data.impact_evident = '';
			data.achievement_group_id = ''  ;
			data.progress_area_id = '' ;
			data.comment = '' ;
			data.child_id = this.props.child_id ;
			data.exemption_reason = this.refs.InputExemptionReason.getValue() ;
		}
		else
		{
			data.spend_reason_id = this.refs.InputReason.getValue() ;

			if ( this.state.spendReason === 100)
			{
				data.spend_reason_text = this.refs.InputSpendReasonText.getValue() ;
			}
			else
			{
				data.spend_reason_text = null ;
			}

			data.impact_evident = this.refs.InputIsHavingImpact.getValue() ;
			data.achievement_group_id = this.refs.InputAchievementGroup.getValue()  ;
			data.progress_area_id = this.refs.InputAchievementGroup.getValue()  ;
			data.comment = this.refs.InputEvidence.getValue()  ;
			data.child_id = this.props.child_id ;
			data.exemption_reason = '' ;
		}

		return data ;
	}

	doSave( callback )
	{
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true })
		}
		else
		{
			const pp_data = this.getFormData() ;

			this.updatePPPlus (pp_data, callback ) ;
		}
	}

	onLeave()
	{
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true })
		}
		else
		{
			if ( this.props.autoSave == true )
			{
				if (this.formIsValid())
				{
					this.autoSave() ;
				}
			}
		}
	}
	
	autoSave()
	{
		if ( this.isDirty() )
		{
			this.doSave() ;			
		}
	}

	isDirty()
	{
		var result = false ;

		if ( this.state.isPPPlusExempt == true )
		{
			if ( this.refs.InputExemptionReason.isDirty() )
			{
				result = true ;
			}
		}
		else
		{
			if ( this.refs.InputReason.isDirty() || this.refs.InputIsHavingImpact.isDirty() || this.refs.InputAchievementGroup.isDirty() || this.refs.InputEvidence.isDirty())
			{
				result = true ;
			}
		}

		if ( this.refs.InputPPPlusNotApplicable.isDirty()  )
		{
			result = true ;
		}

		return result ;
	}	
	
	setDirty( value )
	{
		this.refs.InputPPPlusNotApplicable.setDirty( value );

		if ( this.state.isPPPlusExempt == true )
		{
			this.refs.InputExemptionReason.setDirty( value ) ;
		}
		else
		{
			this.refs.InputReason.setDirty(value);
			this.refs.InputIsHavingImpact.setDirty(value);
			this.refs.InputAchievementGroup.setDirty(value);
			this.refs.InputEvidence.setDirty(value);
			this.refs.InputPPPlusNotApplicable.setDirty(value);
		}

		if ( value == false )
		{
			if ( this.props.setDirty != null )
			{
                this.props.setDirty(value) ;
			}
		}
	}

	onSave() 
	{
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true })
		}
		else
		{
			// Just pass the click back to the creating form
			this.props.doSave();
		}
	}

    title()
	{
		let title = "Pupil Premium Plus " ;

		if ( this.props.attendanceData != null && this.props.attendanceData.description != null )
		{
			const year = +this.props.attendanceData.year_start ;
			const nextYear = year + 1 ;

			title += year + ' - ' + nextYear ;
		}
		else
		{
			if ( this.props.year != null )
			{
				const year = +this.props.year ;
				const nextYear = year + 1 ;

				title += year + ' - ' + nextYear ;
			}
		}

		return title;
	}

	reasonRows()
	{
		return this.props.reasonRows ;
	}

	onClickEdit()
	{
		this.setState ( {mode: 'modify'});
	}

	onClickCancel()
	{
		this.setState ( {mode: 'edit'});
	}

	onComplete()
	{
		let me = this ;

		bootbox.alert({
			size: "large",
			title: "Operation completed",
			message: "The data has been saved.",
			callback: function()
			{
				me.setState ( {mode: 'edit'});
			}
		})
	}

	onClickSave()
	{
		let data = this.getFormData() ;

		this.setState ( { ppplus: data });

		this.doSave ( this.onComplete.bind(this));
	}

	panelHeader ( title, allow_edit, disabled )
	{
		let lineList = [] ;
		let contents = [] ;

		contents.push ( React.createElement ( 'span', { key: 'PanelHeaderSpanDIV' }, title ));

		let handler =  this.onClickEdit.bind(this)  ;
		let icon = 'glyphicon-pencil' ;
		let style = 'panel-header-control-edit' ;
		let tip = 'Edit this PP Plus record' ;

		if ( allow_edit == 1 )
		{
			if ( this.state.mode == 'modify')
			{
				handler = this.onClickCancel.bind(this) ;
				icon = 'glyphicon-ban-circle' ;
				style = 'panel-header-control-delete' ;
				tip = "Cancel Edit" ;
			}
		}

		contents.push ( React.createElement (  PanelControlDelete, { key: 'PanelHeaderIconDIV', disabled: disabled, tip: tip, onClick: handler, enabledStyle: style, glyphicon: icon} ));

		lineList.push ( React.createElement ( 'div', { key: 'PanelHeaderDIV', className: 'panel-heading' }, contents ));

		return lineList ;
	}

	saveButtonRow ( )
	{
		var lineList=[];

		lineList.push ( React.createElement ( BootstrapCol, { key: 'SaveButtonColDIV', width: 9},null)) ;

		lineList.push ( React.createElement ( 'div',{key: 'SaveButtonCol1DIV', className: 'col-md-3' },
			React.createElement('button', { id: 'SaveButton', type: 'button', className: 'btn btn-primary', style: { float: 'right' } , onClick: this.onClickSave.bind(this) }, 'Save'),
			React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right', marginRight: '10px' }, onClick: this.onClickCancel.bind(this) }, 'Cancel')))

		return React.createElement(BootstrapRow, { key: 'SaveButtonRowDiv' , style: { marginTop: '10px'}}, lineList );
	}

	onChange = ( value ) =>
	{
		console.log ( value ) ;
		this.setState({spendReason: +(value)})
	}

	spentOnRow(readOnly)
	{
		var lineList=[];

		lineList.push(
			React.createElement ( 'div', { className: 'col-md-6', key: 'ReasonDiv' } ,
			React.createElement ( DropdownPPPlusReasons, {
				ref: 'InputReason',
				validation:  { required: true },
				label: 'What is it being used for?',
				key: 'InputReason',
				errorText: 'Valid reason required',
				defaultValue: this.state.ppplus.spend_reason_id,
				onDirty: this.onDirty,
				readOnly: readOnly,
				onChange: this.onChange,
				displayErrors:this.state.displayErrors
			})));

		lineList.push( React.createElement ( 'div',{key: 'InputIsHavingImpactDIV' ,className: 'col-md-6'},
			React.createElement ( DropdownYesNo, {
				validation: { required: true },
				id: 'InputIsHavingImpact',
				name: 'InputIsHavingImpact',
				key: 'InputIsHavingImpact',
				ref: 'InputIsHavingImpact',
				label: 'Is it having an impact? (Y/N)',
				errorText: 'You must select a value',
				defaultValue: this.state.ppplus.impact_evident,
				readOnly: readOnly,
				onDirty: this.onDirty,
				containerClassName: '',
				displayErrors:this.state.displayErrors,
			})));

		return React.createElement ( 'div', { className: 'row', key: 'ReasonDivRow' }, lineList ) ;
	}

	achievementGroupRow(readOnly)
	{
		let lineList = [] ;

		lineList.push ( React.createElement ( 'div', { key: 'InputAchievementGroupDIV', className: 'col-md-12'},
			React.createElement ( ReactDropdownAchievementGroupsWithNotifications, {
				validation: { required: true},
				mode: 'list',
				id: 'InputAchievementGroup',
				ref: 'InputAchievementGroup',
				name: 'InputAchievementGroup',
				key: 'InputAchievementGroup',
				label: 'Select an achievement group',
				errorText: 'You must select a group',
				defaultValue: this.state.ppplus.progress_area_id,
				readOnly: readOnly,
				displayErrors:this.state.displayErrors,
				onDirty: this.onDirty,
			}))) ;

		return React.createElement ( 'div', { className: 'row', key: 'AgRow' }, lineList ) ;
	}

	evidenceRow(readOnly)
	{
		let lineList = [] ;

		lineList.push ( React.createElement ( 'div', { key: 'InputEvidenceDIV', className: 'col-md-12'},
			React.createElement ( UserInputTextarea, {
				validation: {required: true, maxlen: 255},
				id: 'InputEvidence',
				name: 'InputEvidence',
				ref: 'InputEvidence',
				key: 'InputEvidence',
				label: 'Evidence of Impact',
				errorText: 'Please enter some evidence text',
				value: this.state.ppplus.comment,
				readOnly: readOnly,
				displayErrors: this.state.displayErrors,
				onDirty: this.onDirty,
			})));

		return React.createElement ( 'div', { className: 'row', key: 'EvidenceRow' }, lineList ) ;
	}

	exemptionReasonRow(readOnly)
	{
		let lineList = [] ;

		lineList.push ( React.createElement ( 'div', { key: 'InputExemptionReaseonDIV', className: 'col-md-12'},
			React.createElement ( UserInputTextarea, {
				validation: {required: true, maxlen: 255},
				id: 'InputExemptionReason',
				name: 'InputExemptionReason',
				ref: 'InputExemptionReason',
				key: 'InputExemptionReason',
				label: 'Reason',
				errorText: 'Please enter some reason text',
				value: this.state.ppplus.exemption_reason,
				readOnly: readOnly,
				displayErrors: this.state.displayErrors,
				onDirty: this.onDirty,
			})));

		return React.createElement ( 'div', { className: 'row', key: 'InputExemptionReaseonRow' }, lineList ) ;
	}

	spendReasonTextRow(readOnly)
	{
		let lineList = [] ;

		lineList.push ( React.createElement ( 'div', { key: 'InputSpendReasonTextDIV', className: 'col-md-12'},
			React.createElement ( UserInputTextarea, {
				validation: {required: true, maxlen: 255},
				id: 'InputSpendReasonText',
				name: 'InputSpendReasonText',
				ref: 'InputSpendReasonText',
				key: 'InputSpendReasonText',
				label: 'Please enter details of what the PP Plus is being used for',
				errorText: 'Please enter details',
				value: this.state.ppplus.spend_reason_text,
				readOnly: readOnly,
				displayErrors: this.state.displayErrors,
				onDirty: this.onDirty,
			})));

		return React.createElement ( 'div', { className: 'row', key: 'InputSpendReasonTextRow' }, lineList ) ;
	}

	onExemptFlagChange ( newValue )
	{
		this.setState ({isPPPlusExempt : newValue}) ;
	}

	rowPPPlusExempt(readOnly)
	{
		return (
			<BootstrapRow key='InputPPPlusNotApplicableRowDIV' >
				<BootstrapCol width={12}>
					<UserInputCheckbox
					readOnly={readOnly}
					ref='InputPPPlusNotApplicable'
					defaultValue={this.state.isPPPlusExempt}
					onDirty={this.onDirty}
					onChange={this.onExemptFlagChange}
					label='Check if Pupil Premium Plus does not apply' />
				</BootstrapCol>
			</BootstrapRow>
		)
	}

    p1()
	{
		var lineList=[];
		let panelList = [] ;

		let readOnly = '';

		if ( this.state.mode === 'view' || this.state.mode === 'qa' || ( this.props.setting === 'child' &&  this.state.mode === 'edit' ))
		{
			readOnly = 'readonly';
		}

		const disabled = this.props.setting !== 'child' ;

		lineList.push ( this.panelHeader (this.title(), 1, disabled));

		if ( this.props.isPPPlus === true )
		{
			panelList.push ( this.rowPPPlusExempt(readOnly) ) ;

			if ( this.state.isPPPlusExempt === false )
			{
				panelList.push ( this.spentOnRow(readOnly)) ;

				if ( this.state.spendReason === 100 )
				{
					panelList.push ( this.spendReasonTextRow(readOnly)) ;
				}

				panelList.push ( this.achievementGroupRow(readOnly)) ;
				panelList.push ( this.evidenceRow(readOnly)) ;
			}
			else
			{
				panelList.push( this.exemptionReasonRow(readOnly)) ;
			}

			if ( this.state.mode === 'modify' )
			{
				panelList.push(this.saveButtonRow()) ;
			}

			lineList.push ( <div key='MainPanelBodyDiv' className='panel-body'>{panelList}</div> );
		}
		else
		{
			lineList.push ( <div key='MainPanelBodyDiv' className='panel-body'>This pupil is not eligible for PP Plus</div> );
		}

		lineList.push ( <ReactTooltip key='tooltipPPPDiv' className='tool-class' ref='tooltipAttendance' />);

		return React.createElement ( 'div', { key: 'MainPanelDIV', className: 'panel' + ' ' + this.props.panelStyle }, lineList) ;
	}

	formRows ()
	{
		return (
			<Fragment>
				{ this.p1() }
				{ this.navFormRow() }
			</Fragment>
		)
	}
	
	render() 
    {
		return this.state.loading === true ? <SpinnerDiv /> : this.formRows()
  	}
}
